import type { ResourceScope } from "../../Query/resourceKeys";
import { queryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import { resourceKeys } from "../../Query/resourceKeys";

export function notificationQueryKey(scope: ResourceScope, functionName: string, ...args: unknown[]) {
  return [...resourceKeys.notifications.list(scope), functionName, ...args] as const;
}

export function fetchNotificationQuery<T>(
  scope: ResourceScope,
  functionName: string,
  args: unknown[],
  queryFn: (ctx: { signal?: AbortSignal }) => Promise<T>,
): Promise<T> {
  return queryClient.fetchQuery({
    queryKey: notificationQueryKey(scope, functionName, ...args),
    queryFn,
  });
}
